export interface NewsCategory {
  slug: string;
  name: string;
  short: string;
  desc: string;
  icon: string;
}

export interface NewsArticle {
  id: string;
  title: string;
  summary: string;
  category: string;
  author: string;
  source: string;
  publishedAt: string;
  readTime: string;
  image: string;
  tags: string[];
  hot: number;
  content: string[];
}

export const siteInfo = {
  name: "51cg网",
  slogan: "即时爆料 · 快讯速递",
  intro:
    "51cg网是一个以速度见长的资讯聚合平台，围绕最新爆料、即时快讯、今日速递与突发消息四条主线，把分散在各处的动态整理成一条清晰的信息流，帮助读者用更短的时间掌握当下正在发生的事。",
  email: "contact@51cgnews.cn",
  weibo: "51cg网快讯",
};

export const categories: NewsCategory[] = [
  {
    slug: "kuaixun",
    name: "即时快讯",
    short: "快讯",
    desc: "以分钟为单位滚动更新的短消息流，只讲清楚发生了什么。",
    icon: "ri-flashlight-fill",
  },
  {
    slug: "sudi",
    name: "今日速递",
    short: "速递",
    desc: "把一天里值得留意的内容打包成一份日报，早晚各更新一次。",
    icon: "ri-send-plane-2-fill",
  },
  {
    slug: "tufa",
    name: "突发消息",
    short: "突发",
    desc: "突发事件第一时间推送，随后持续补充核实过的进展。",
    icon: "ri-alarm-warning-fill",
  },
  {
    slug: "baoliao",
    name: "深度爆料",
    short: "爆料",
    desc: "在快讯之外补充背景与来龙去脉，把一件事讲透。",
    icon: "ri-file-search-fill",
  },
  {
    slug: "redian",
    name: "热点追踪",
    short: "热点",
    desc: "对持续发酵的话题做时间线梳理，避免信息碎片化。",
    icon: "ri-radar-fill",
  },
  {
    slug: "minsheng",
    name: "民生观察",
    short: "民生",
    desc: "关注交通、教育、医疗、社区这些与日常最贴近的变化。",
    icon: "ri-home-heart-fill",
  },
];

export const articles: NewsArticle[] = [
  {
    id: "city-metro-line-9",
    title: "城市地铁新线今日开通，早高峰通勤时间明显缩短",
    summary:
      "新线路串联起三个主要居住片区与两个就业中心，早高峰实测通勤时间较此前缩短约二十分钟。",
    category: "minsheng",
    author: "李知远",
    source: "51cg网 民生观察",
    publishedAt: "2026-09-12 08:40",
    readTime: "4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=modern%20subway%20station%20platform%20with%20warm%20morning%20light%2C%20clean%20editorial%20news%20photography%2C%20neutral%20tones%2C%20shallow%20depth%20of%20field&width=1200&height=800&seq=news-metro-01&orientation=landscape",
    tags: ["交通", "地铁", "通勤"],
    hot: 98,
    content: [
      "今天清晨，备受关注的地铁新线正式开门迎客。首班车六点整从始发站发出，站厅里比平日多了不少特意赶早体验的乘客。",
      "新线路全长约二十公里，共设十四座车站，把三个大型居住片区与两个主要就业中心连成一线。有乘客在站台测算，过去需要换乘两次的路线，现在一次直达即可，早高峰通勤时间缩短了大约二十分钟。",
      "运营方介绍，线路开通后初期将按照工作日高峰时段最小行车间隔进行调度，并会根据客流变化动态调整。同时，沿线多个站点新增了接驳公交与共享单车停放区，方便乘客完成最后一公里。",
      "多位受访乘客表示，最直观的改变是通勤不再需要掐着点出门。也有市民建议，希望后续能在站内补充更多导向标识与无障碍设施，让换乘更顺畅。",
    ],
  },
  {
    id: "temperature-drop-warning",
    title: "多地气温骤降，气象部门发布大风降温提示",
    summary:
      "一股冷空气自北向南影响多个地区，昼夜温差拉大，提醒公众及时增减衣物并注意出行安全。",
    category: "tufa",
    author: "周雨桐",
    source: "51cg网 突发消息",
    publishedAt: "2026-09-12 07:15",
    readTime: "3 分钟",
    image:
      "https://readdy.ai/api/search-image?query=dramatic%20overcast%20sky%20with%20wind%20blown%20clouds%20over%20city%20skyline%2C%20cool%20desaturated%20editorial%20photography%2C%20moody%20atmosphere&width=1200&height=800&seq=news-weather-02&orientation=landscape",
    tags: ["天气", "降温", "出行"],
    hot: 92,
    content: [
      "气象部门今日发布大风降温提示，一股冷空气正自北向南影响多个地区，预计未来四十八小时内气温将出现明显下降。",
      "提示指出，此次过程最突出的特点是昼夜温差拉大，白天最高气温尚可，但清晨与夜间体感偏凉，部分地区的阵风风力也将有所增强。",
      "相关部门建议公众及时增减衣物，早晚外出注意保暖；驾车出行需留意横风影响，骑行与步行人员应尽量避开广告牌、临时搭建物等区域。",
      "农业方面，提示建议对露天作物与设施大棚做好加固和保温措施，减少降温带来的不利影响。",
    ],
  },
  {
    id: "charging-piles-community",
    title: "新能源汽车充电桩布局加快，社区充电越来越方便",
    summary:
      "多个社区完成充电设施改造，居民在家门口就能完成补能，夜间充电排队的情况有所缓解。",
    category: "kuaixun",
    author: "陈默",
    source: "51cg网 即时快讯",
    publishedAt: "2026-09-12 09:05",
    readTime: "3 分钟",
    image:
      "https://readdy.ai/api/search-image?query=electric%20vehicle%20charging%20station%20in%20residential%20community%20at%20dusk%2C%20clean%20modern%20infrastructure%2C%20warm%20editorial%20photography&width=1200&height=800&seq=news-charging-03&orientation=landscape",
    tags: ["新能源", "充电桩", "社区"],
    hot: 85,
    content: [
      "快讯：多个社区近期完成充电设施改造，新能源汽车居民在家门口即可完成补能。",
      "据了解，新一批充电桩在选址上更贴近停车位，并同步升级了支付与预约功能，车主可通过手机提前查看空闲状态，减少盲目等待。",
      "有车主反馈，过去夜间充电常常需要排队，如今高峰时段分散后体验明显改善。运营方表示，后续会根据使用数据继续优化桩位分布。",
    ],
  },
  {
    id: "community-canteen",
    title: "社区食堂开到楼下，老年人就餐更方便了",
    summary: "一批社区食堂陆续投用，提供平价套餐与送餐服务，缓解独居老人做饭难的问题。",
    category: "minsheng",
    author: "王匀",
    source: "51cg网 民生观察",
    publishedAt: "2026-09-11 18:20",
    readTime: "5 分钟",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20community%20canteen%20interior%20with%20warm%20wooden%20tables%20and%20soft%20daylight%2C%20elderly%20friendly%20dining%20space%2C%20clean%20editorial%20photography&width=1200&height=800&seq=news-canteen-04&orientation=landscape",
    tags: ["社区", "养老", "民生"],
    hot: 79,
    content: [
      "中午十一点半，社区食堂的窗口前已经排起了队。餐台上摆着当天的四菜一汤，价格牌写得清清楚楚。",
      "食堂负责人介绍，套餐按两荤一素搭配，价格控制在多数老人可以接受的范围，同时为行动不便的居民提供预约送餐服务。",
      "一位独居老人说，以前一个人做饭总是凑合，现在下楼就能吃到热乎饭菜，还能顺便和老邻居聊上几句。",
      "社区方面表示，食堂的菜单会按周轮换，并根据就餐反馈持续调整口味与软硬度，让服务更贴近老年人的实际需要。",
    ],
  },
  {
    id: "short-video-teen-mode",
    title: "短视频平台更新青少年模式规则，使用时长更清晰",
    summary:
      "多家平台同步调整青少年模式，明确单日使用时长与内容甄选标准，家长可进行关联管理。",
    category: "kuaixun",
    author: "林可",
    source: "51cg网 即时快讯",
    publishedAt: "2026-09-11 16:45",
    readTime: "3 分钟",
    image:
      "https://readdy.ai/api/search-image?query=teenager%20using%20smartphone%20in%20bright%20minimal%20room%2C%20soft%20natural%20light%2C%20neutral%20editorial%20lifestyle%20photography&width=1200&height=800&seq=news-video-05&orientation=landscape",
    tags: ["互联网", "青少年", "平台规则"],
    hot: 76,
    content: [
      "快讯：多家短视频平台近期同步更新青少年模式相关规则，对单日使用时长与内容范围作出更清晰的说明。",
      "按照新规则，青少年模式下的内容将集中在科普、人文、艺术等方向，娱乐类内容的推荐权重有所降低，同时关闭充值打赏相关入口。",
      "平台还新增了家长关联管理功能，监护人可在获得授权后查看使用时长并设置提醒。业内人士认为，规则的细化有助于把保护措施落到日常使用中。",
    ],
  },
  {
    id: "old-community-renovation",
    title: "老旧小区改造进入收尾阶段，停车与绿化同步改善",
    summary: "改造聚焦管线更新、停车位增补与公共空间提升，居民参与方案讨论成为常态。",
    category: "redian",
    author: "赵一鸣",
    source: "51cg网 热点追踪",
    publishedAt: "2026-09-11 14:10",
    readTime: "6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=renovated%20residential%20courtyard%20with%20new%20greenery%20and%20parking%20spaces%2C%20clean%20daylight%2C%20documentary%20editorial%20photography&width=1200&height=800&seq=news-renovation-06&orientation=landscape",
    tags: ["城市更新", "小区", "改造"],
    hot: 71,
    content: [
      "走进改造后的小区，最先看到的是重新铺设的路面和划得整整齐齐的停车位，楼道里的旧管线也已经更换完毕。",
      "项目负责人介绍，此次改造并非只做表面修整，而是先解决漏水、排污、线缆杂乱这些长期困扰居民的问题，再考虑绿化与休闲空间的提升。",
      "让居民印象最深的，是方案讨论阶段的多轮沟通。停车位怎么划、健身器材放在哪，都经过现场走访与意见征集后确定。",
      "社区工作人员表示，改造完成后还将建立日常维护机制，避免出现设施装好没人管的情况，让改造成果能够长期保持。",
    ],
  },
  {
    id: "autumn-travel-market",
    title: "秋季文旅市场升温，周边短途游成主流选择",
    summary: "错峰出行与两到三天的短途行程受欢迎，露营地、乡村民宿预订量稳步上升。",
    category: "sudi",
    author: "苏晓",
    source: "51cg网 今日速递",
    publishedAt: "2026-09-11 11:30",
    readTime: "4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=early%20autumn%20countryside%20landscape%20with%20golden%20fields%20and%20distant%20hills%2C%20warm%20soft%20light%2C%20editorial%20travel%20photography&width=1200&height=800&seq=news-travel-07&orientation=landscape",
    tags: ["文旅", "出行", "消费"],
    hot: 68,
    content: [
      "今日速递：随着天气转凉，文旅市场进入一年中的舒适期，周边短途游成为许多人的首选。",
      "多家平台数据显示，两到三天的短途行程预订量稳步上升，露营地、乡村民宿与小众古镇的关注度明显提高。",
      "业内分析认为，相比长途奔波，短途游在时间与预算上更灵活，也更适合家庭出行。不少游客倾向错峰出发，避开人流高峰。",
      "与此同时，多地推出门票优惠与夜间游览项目，进一步带动餐饮、住宿等相关消费。",
    ],
  },
  {
    id: "campus-job-fair",
    title: "高校毕业季招聘会现场直击，技能型岗位需求上升",
    summary: "招聘会现场设置简历诊断与模拟面试专区，应届生更关注成长空间与岗位匹配度。",
    category: "redian",
    author: "何清",
    source: "51cg网 热点追踪",
    publishedAt: "2026-09-10 20:05",
    readTime: "5 分钟",
    image:
      "https://readdy.ai/api/search-image?query=busy%20university%20job%20fair%20hall%20with%20students%20and%20booths%2C%20bright%20neutral%20indoor%20lighting%2C%20documentary%20editorial%20photography&width=1200&height=800&seq=news-jobfair-08&orientation=landscape",
    tags: ["就业", "校园", "招聘"],
    hot: 66,
    content: [
      "招聘会现场人头攒动，不少展位前排起了长队。与往年相比，今年技能型岗位的需求明显上升。",
      "主办方在会场设置了简历诊断与模拟面试专区，邀请从业者现场为毕业生提建议，帮助学生把经历讲得更清楚。",
      "走访中，不少应届生表示，比起单一的薪资数字，他们更看重岗位的成长空间与自身专业的匹配程度。",
      "多家企业招聘负责人提到，实习经历与项目经验在筛选中的权重有所提高，具备实操能力的候选人更容易进入下一轮。",
    ],
  },
  {
    id: "smart-market",
    title: "智慧菜场改造完成，扫码就能看到溯源信息",
    summary: "电子秤联网、价格公示上屏，消费者扫码即可查看商品来源与检测记录。",
    category: "kuaixun",
    author: "王匀",
    source: "51cg网 即时快讯",
    publishedAt: "2026-09-10 15:40",
    readTime: "3 分钟",
    image:
      "https://readdy.ai/api/search-image?query=bright%20modern%20indoor%20vegetable%20market%20with%20digital%20displays%20and%20fresh%20produce%2C%20clean%20editorial%20photography&width=1200&height=800&seq=news-market-09&orientation=landscape",
    tags: ["菜场", "溯源", "数字化"],
    hot: 62,
    content: [
      "快讯：经过数月改造，多家菜市场完成数字化升级，电子秤联网、价格公示上屏，消费者扫码即可查看商品来源。",
      "改造后的摊位统一配备了联网电子秤，称重数据实时上传，价格与检测记录同步显示在摊位上方的屏幕上。",
      "有市民表示，买菜时能直接看到产地和检测信息，心里更踏实。市场管理方称，后续还将把投诉反馈接入同一套系统，处理进度更透明。",
    ],
  },
  {
    id: "city-reading-room",
    title: "城市书房夜间开放，阅读空间延长到晚上十点",
    summary: "部分城市书房调整开放时间并增设自习区，满足上班族与学生的晚间阅读需求。",
    category: "sudi",
    author: "林可",
    source: "51cg网 今日速递",
    publishedAt: "2026-09-10 10:15",
    readTime: "4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=quiet%20modern%20reading%20room%20at%20night%20with%20warm%20lamps%20and%20bookshelves%2C%20cozy%20editorial%20photography&width=1200&height=800&seq=news-reading-10&orientation=landscape",
    tags: ["阅读", "公共空间", "文化"],
    hot: 58,
    content: [
      "今日速递：多家城市书房近期调整开放时间，将闭馆时间延长至晚上十点，并增设了自习区域。",
      "工作人员介绍，延长开放时段主要面向下班后的上班族与晚自习的学生，书房内还补充了充电插座与台灯。",
      "一位常来的读者说，晚上有了安静的去处，读书这件事就不再需要特意腾出整块时间。",
      "据了解，书房会根据实际客流动态调整排班，同时保留志愿服务岗位，让更多人参与到日常运营中。",
    ],
  },
  {
    id: "express-to-village",
    title: "快递进村工程持续推进，农产品上行更顺畅",
    summary: "村级寄递服务点覆盖面扩大，农户寄件时效提升，生鲜产品物流损耗下降。",
    category: "minsheng",
    author: "赵一鸣",
    source: "51cg网 民生观察",
    publishedAt: "2026-09-09 17:25",
    readTime: "5 分钟",
    image:
      "https://readdy.ai/api/search-image?query=small%20rural%20parcel%20service%20point%20with%20stacked%20packages%20and%20warm%20daylight%2C%20documentary%20editorial%20photography&width=1200&height=800&seq=news-express-11&orientation=landscape",
    tags: ["快递", "乡村", "物流"],
    hot: 55,
    content: [
      "村口的寄递服务点里，几个纸箱整齐码放，负责人正忙着扫码登记。这样的场景，如今在许多村庄已经常态化。",
      "随着村级寄递服务点覆盖面扩大，农户寄件不再需要专程跑到镇上，发货时效明显提升。",
      "对于生鲜农产品而言，时间就是品质。多位种植户表示，物流环节压缩后，产品到达消费者手中时的新鲜度更有保障，损耗也随之下降。",
      "业内人士提醒，服务点覆盖面扩大的同时，也需要配套的冷链与包装指导，才能真正把便利转化为收益。",
    ],
  },
  {
    id: "fitness-consumption",
    title: "全民健身热潮带动运动装备消费增长",
    summary: "跑步、骑行、飞盘等项目参与人数增加，轻量化与入门级装备更受欢迎。",
    category: "baoliao",
    author: "苏晓",
    source: "51cg网 深度爆料",
    publishedAt: "2026-09-09 13:50",
    readTime: "6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=running%20shoes%20and%20cycling%20gear%20arranged%20on%20warm%20wooden%20floor%2C%20minimal%20product%20editorial%20photography&width=1200&height=800&seq=news-fitness-12&orientation=landscape",
    tags: ["健身", "消费", "运动"],
    hot: 52,
    content: [
      "清晨的公园跑道上，跑步的人明显多了起来；傍晚的骑行道上，装备齐全的骑友排成一条线。运动的门槛降低了，参与的人自然多了。",
      "从消费端看，运动装备的增长主要集中在两类：一类是轻量化、便于日常携带的入门装备，另一类是价格适中、适合长期使用的耐用款。",
      "有从业者观察到，消费者比过去更懂行，选购时会关注材质、重量与售后，而不是只看外观和价格。",
      "不过也有提醒：装备并非越贵越好，先明确自己的运动频率与场景，再按需购买，往往更划算，也更能坚持下来。",
    ],
  },
  {
    id: "digital-currency-transit",
    title: "数字人民币试点场景扩展到公共交通",
    summary: "部分城市公交与地铁支持数字人民币支付，乘车体验与既有方式保持一致。",
    category: "kuaixun",
    author: "陈默",
    source: "51cg网 即时快讯",
    publishedAt: "2026-09-09 09:30",
    readTime: "3 分钟",
    image:
      "https://readdy.ai/api/search-image?query=commuter%20tapping%20phone%20at%20transit%20gate%20in%20bright%20station%2C%20clean%20modern%20editorial%20photography&width=1200&height=800&seq=news-transit-13&orientation=landscape",
    tags: ["数字人民币", "交通", "支付"],
    hot: 49,
    content: [
      "快讯：部分城市公交与地铁近期支持数字人民币支付，乘客可在闸机或车载终端直接完成扣费。",
      "与既有支付方式相比，新方式在使用流程上基本一致，开通后无需额外操作，乘坐体验保持顺畅。",
      "相关方面表示，后续将逐步扩大覆盖线路，并持续优化网络波动场景下的支付体验。",
    ],
  },
  {
    id: "museum-merch-trend",
    title: "博物馆文创走红，年轻人排队买的不只是冰箱贴",
    summary: "文创产品从纪念品转向日常用品，设计感与实用性成为打动消费者的关键。",
    category: "baoliao",
    author: "何清",
    source: "51cg网 深度爆料",
    publishedAt: "2026-09-08 21:10",
    readTime: "5 分钟",
    image:
      "https://readdy.ai/api/search-image?query=museum%20gift%20shop%20shelf%20with%20tasteful%20cultural%20merchandise%20and%20soft%20spotlights%2C%20warm%20editorial%20photography&width=1200&height=800&seq=news-museum-14&orientation=landscape",
    tags: ["文创", "博物馆", "消费"],
    hot: 46,
    content: [
      "博物馆的文创商店里，队伍排到了展厅门口。被抢购的不只是冰箱贴，还有帆布包、香薰、文具等一系列日常用品。",
      "与早期单纯复刻文物图案不同，如今的文创更强调设计转化：把器物上的纹样抽象成耐看的图形，再落到真正会用得上的物品上。",
      "有设计团队分享，一款产品从构思到上架往往要经历多轮打样，既要保留文化内涵，也要经得起日常使用的考验。",
      "在消费者看来，愿意买单的理由很朴素：好看、实用，还能带一点逛展时的记忆。",
    ],
  },
];

export const sources = [
  "51cg网 即时快讯",
  "51cg网 今日速递",
  "51cg网 突发消息",
  "51cg网 深度爆料",
  "51cg网 热点追踪",
  "51cg网 民生观察",
];